import gql from 'graphql-tag';

export default gql`
  fragment ReverbHeaderUserMenuData on rql_Me {
    shop {
      _id
      slug
      paymentMethod
    }
    reverbCredits {
      display
      currency
    }
    payoutBalances {
      display
      currency
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/reverb_header/reverb_header_user_menu_fragment.ts